import React, { useEffect, useState, useContext } from "react";
import Backdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import Button from "../SelectValue/Button";
import PinInput from "react-pin-input";
import { Outlet, useNavigate } from "react-router-dom";
import CancelIcon from "@mui/icons-material/Cancel";
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";
import Back from "../Back";
import postService from "../../Services/post-service";
import Loading from "../SelectValue/Loading";
import getServices from "../../Services/get-service";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { usePaystackPayment } from "react-paystack";
import { UserContext } from "../../Context/UserContext";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 430,
  minHeight: 420,
  bgcolor: "white",
  boxShadow: 24,
  borderRadius: "16px",
  p: 4,
  maxWidth: "95%",
  outline: "none",
};

export default function Pin({ open, handleClose, id, unit, method, amount, closeBuyUnit }) {
  const [pin, setPin] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!open) {
      setPin("");
      setLoading(false);
    }
  }, [open]);

  const { userDetails } = useContext(UserContext);
  const email = userDetails?.emailAddress;

  const initialConfig = {
    reference: null,
    email: email,
    amount: 0,
    publicKey: process.env.REACT_APP_PAYSTACK_KEY,
  };
  const [configP, setConfig] = useState(initialConfig);

  useEffect(() => {
    if (email) {
      setConfig((prev) => ({ ...prev, email: email }));
    }
  }, [email]);

  let initializePayment = usePaystackPayment(configP);
  const navigate = useNavigate();
  const handleSubmit = (e, pinValue) => {
    if (e) e.preventDefault();
    const finalPin = pinValue || pin;

    setLoading(true);
    postService.buyProject(id, unit, finalPin).then(
      (response) => {
        setLoading(false);
        if (response.data.statusCode === 200) {
          toast.success("Investment made successfully");
          if (closeBuyUnit) closeBuyUnit();
          handleClose();
          setTimeout(() => {
            navigate("/buy");
          }, 1000);
        } else {
          toast.error(response.data.description);
          if (closeBuyUnit) closeBuyUnit();
          handleClose();
          setTimeout(() => {
            window.location.reload();

          }, 5000);
        }
      },
      (error) => {
        setLoading(false);
        if (closeBuyUnit) closeBuyUnit();
        handleClose();
        return toast.error(error?.response?.data?.description, {
          autoClose: 1000,
          position: toast.POSITION.TOP_CENTER,
        });
      }
    );
  };
  const onSuccess = (reference) => {

    verifyPayment(reference.reference);
  };


  const onClose = () => {

  };
  const verifyPayment = (ref) => {
    // setLoading(true)
    // getServices.getVerifySavingPayment(ref).then(
    //   (response) => {
    //     setLoading(false)
    //     navigate('/buy')

    //   },
    //   (error) => {
    //     setLoading(false)

    //     navigate('/buy')

    //   }
    // )
    navigate("/buy");
  };

  useEffect(() => {
    if (configP.reference === null || configP.email === undefined) return;
    initializePayment(onSuccess, onClose);
  }, [configP]);
  return (
    <div>
      <Outlet />
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={open}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={open}>
          <Box sx={{ ...style, display: "flex", flexDirection: "column" }}>
            <Loading open={loading} />
            <div className="flex justify-end mb-4">
              <IconButton
                onClick={handleClose}
                sx={{
                  bgcolor: "#1F2937",
                  color: "white",
                  "&:hover": { bgcolor: "#374151" },
                  width: 36,
                  height: 36,
                }}
              >
                <CloseIcon fontSize="small" />
              </IconButton>
            </div>

            <div className="mb-8">
              <p className="font-[700] text-[20px] text-back-color2 mb-2">
                Enter your Zouse PIN
              </p>
              <p className="text-[14px] text-gray-500">
                Enter your 4-Digit PIN to confirm transaction
              </p>
            </div>

            <form onSubmit={handleSubmit} className="flex flex-col flex-1">
              <div className="flex justify-center mb-10">
                <PinInput
                  length={4}
                  initialValue={pin}
                  secret
                  onChange={(value, index) => setPin(value)}
                  type="numeric"
                  inputMode="number"
                  style={{ padding: "10px" }}
                  inputStyle={{
                    borderColor: "#00BC67",
                    backgroundColor: "#FAFBFC",
                    borderRadius: 8,
                    margin: "0 5px",
                    width: "50px",
                    height: "50px",
                    fontSize: "24px",
                    fontWeight: "700"
                  }}
                  inputFocusStyle={{
                    borderColor: "#00BC67",
                    backgroundColor: "#CCF2E1",
                  }}
                  onComplete={(value, index) => setPin(value)}
                  autoSelect={true}
                  regexCriteria={/^[ A-Za-z0-9_@./#&+-]*$/}
                />
              </div>

              <button
                type="submit"
                className="mt-auto w-full bg-[#00BC67] text-white font-[700] py-4 rounded-xl transition-colors text-[18px]"
              >
                Confirm
              </button>
            </form>
          </Box>
        </Fade>
      </Modal>
    </div>
  );
}
